export const sortByDate = (data, desc = false, isMarket = false) => {
  const fieldToSort = isMarket ? 'openingDay' : 'day'
  const sortedItems = data.sort((a, b) => {
    return desc
      ? new Date(b[fieldToSort]) - new Date(a[fieldToSort])
      : new Date(a[fieldToSort]) - new Date(b[fieldToSort])
  })
  return sortedItems
}
